define('editor/edit/layers/add/legend/index',['durandal/app', 'plugins/http', 'knockout', 'knockout-mapping', 'jquery', '../../edit/legendBase', '../../helpers', 'no-ui-slider', 'tinycolorpicker'], function (app, http, ko, komapping, $, legendBase, helper) {
    var viewmodel = function() {
        var self = this;

        var moduleId = self.__moduleId__;
        self.base = new legendBase(false);
        $.extend(self, self.base);
        self.__moduleId__ = moduleId;
        self.name = ko.observable();

        self.activate = function (editorMapId, cancelFunc) {
            self.base.activate(editorMapId);
            self.editorMapId = editorMapId;
            self.exit = cancelFunc;
        };

        self.save = function () {
            self.createItem();
            self.saveLayer(self.items()).then(self.exit);
        };
        
        self.saveLayer = function (items) {
            var url = "/api/editor/layers/add",
                state = {
                    items: items,
                    itemSize: self.itemSize(),
                    width: 100,
                    height: 100,
                    position: {
                        x: 0,
                        y: 0
                    }
                },
                data = {
                    editorMapId: self.editorMapId,
                    type: 'Legend',
                    name: self.name(),
                    state: state
                };

            return http.post(url, data)
                .then(function(response) {
                    if (response.success) {
                        var layerData = response.data["createdLayer"],
                            layerState = komapping.fromJS(layerData.state),
                            layer = {
                                id: ko.observable(layerData.id),
                                name: ko.observable(layerData.name),
                                groupId: ko.observable(data.groupId),
                                groupName: ko.observable(data.groupName),
                                groupColour: ko.observable(data.groupColour),
                                visible: ko.observable(layerData.visible),
                                type: ko.observable(layerData.type),
                                order: ko.observable(layerData.order),
                                state: ko.observable(layerState)
                            };

                        delete layerState['__ko_mapping__'];

                        app.trigger("layer:new", layer);
                    } else {
                        app.showMessage("Failed to add layer", "Add Layer");
                    }
                });
        };
    };

    return viewmodel;
});

